import { getPrivateApi } from "../lib/axiosConfig";
import { LaundryActivation, LaundryMachineOption, LaundryTypeOption, Receipt, TotemOrder, TotemTransaction, TransactionError, TransactionReturn } from "../types/laundry.types";
import { AppError } from "./classes";
import { retry } from "./generic";

const api = getPrivateApi();

export const getLaundryTypesByStation = async (station: string): Promise<LaundryTypeOption[]> => {
  try {
    const { data } = await api.get(`/laundry-types/station/${station}`);

    if(!data || data.length === 0) {
      const errMsg = "Erro ao buscar tipos de lavanderia.";
      console.error(errMsg);
      throw new AppError(errMsg, 500);
    }

    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar tipos de lavanderia.";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
};

export const getLaundryMachinesByStation = async (station: string, type?: string): Promise<LaundryMachineOption[]> => {
  try {
    const { data } = await api.get(`/laundry-machines/station/${station}${type ? '?type='+ type : ''}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar tipos de máquinas de lavanderia.";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
};

export const getAllLaundryMachines = async (): Promise<LaundryMachineOption[]> => {
  try {
    const { data } = await api.get('/laundry-machines');
    return data;
  } catch (error: any) {
    const errMsg = "Falha ao buscar máquinas de lavanderia";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
}

export const createTotemTransaction = async (payload: TotemTransaction): Promise<TransactionReturn | TransactionError> => {
  const { amount, paymentType, totemId } = payload;
  const normalizedValue = Math.round(Number(amount) * 100).toString();
  try {
    const response = await api.post(
      `/totem/transaction`,
      {
        totemId,
        appType: paymentType,
        amount: normalizedValue,
      }
    );
    console.log('Transação criada com sucesso:', response.data);
    return { success: true, data: response.data };
  } catch (error: any) {
    console.error('Erro ao criar transação:', error?.response?.data || error.message);
    return { success: false, error: error?.response?.data || error.message };
  }
};

export const createTotemOrder = async (payload: TotemOrder) => {
  const { laundryTypeId, laundryTypePrice, laundryMachineId, paymentType, taxId, totemId, cieloTransactionId } = payload;
  try {
    const response = await api.post(
      `/laundry-orders`,
      {
        laundryType: {
          id: laundryTypeId,
          price: laundryTypePrice,
        },
        laundryMachineId,
        paymentType,
        taxId,
        totemId,
        cieloTransactionId,
      }
    );
    console.log('Ordem criada com sucesso:', response.data);
  } catch (error: any) {
    console.error('Erro ao criar ordem:', error?.response?.data || error.message);
  }
};

export const sendReceipt = async (receipt: Receipt): Promise<void> => {
  try {
    await retry(() =>
      api.post(`/receipts/send`, receipt), 3, 2000
    );
  } catch (error: any) {
    const errMsg = "Erro ao enviar recibo";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
}

export const activateLaundryMachine = async (payload: LaundryActivation): Promise<void> => {
  try {
    await retry(() =>
      api.post('/laundry-machines/publish', payload), 3, 3000
    );
  } catch (error: any) {
    const errMsg = "Erro ao ativar máquina de lavanderia";

    console.error(errMsg, error?.response?.data || error.message || error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  }
}

export const createLaundryMachine = async (payload: any): Promise<void> => {
  try {
    await api.post(`/laundry-machines`, payload);
  } catch (error: any) {
    const errMsg = "Erro ao criar máquina";
    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const deleteLaundryMachine = async (id: string): Promise<void> => {
  try {
    await api.delete(`/laundry-machines/${id}`);
  } catch (error: any) {
    const errMsg = "Erro ao deletar máquina";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const linkDeviceToLaundryMachine = async (laundryMachineId: string, serialNumber?: string): Promise<void> => {
  try {
    await api.put(`laundry-machines/link/${laundryMachineId}${serialNumber ? '?serialNumber='+ serialNumber : ''}`);
  } catch (error: any) {
    const errMsg = "Erro ao vincular dispositivo à máquina de lavanderia";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};
